import { PolicyConfirmModal } from '../policy-confirm-modal'
import type { CancellationPolicySaveWarningModalProps } from './cancellation-policy-save-warning-modal.interface'

export function CancellationPolicySaveWarningModal({ onCancel, onConfirm }: CancellationPolicySaveWarningModalProps) {
  return (
    <PolicyConfirmModal
      title="Save cancellation policy changes?"
      cancelLabel="Cancel"
      confirmLabel="Save changes"
      onCancel={onCancel}
      onConfirm={onConfirm}
      testId="cancellation-policy-save-warning"
    >
      <p>
        The changes apply right away to every upcoming appointment the policy covers, including appointments created
        before today.
      </p>
    </PolicyConfirmModal>
  )
}
